import { ICategory } from '@/models/categories.model';

export const getCategoriesOptions = (categories: ICategory[]) =>
  categories?.map((category: ICategory) => ({ label: category.name, value: category.id }));
